module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/360.66208d08.png";